import React, { useEffect, useState } from "react";
import { maxLengthCheck } from "../../../modules/utils/CheckLogic";

export default (props) => {
  const [dynamicDose, setDynamicDose] = useState(0.01);
  const [injctDose, setInjctDose] = useState(1);

  useEffect(() => {
    if (injctDose) {
      setDynamicDose(0.01 * injctDose);
    }
  }, [injctDose]);

  return (
    <div style={{ height: "67px", marginTop: "8px" }}>
      <div
        style={{
          height: "46px",
          fontSize: "0.9rem",
          width: "48%",
          border: "1px solid #d0d0d0",
          borderRadius: "7px",
          background: "#fff",
          boxSizing: "border-box",
          float: "left",
          padding: "5px",
          paddingLeft: "15px",
        }}
      >
        <input
          type="text"
          name="injctName"
          style={{ border: "0px", width: "100%", height: "100%" }}
          onChange={(e) => maxLengthCheck(e, 10)}
          placeholder="인슐린명"
        />
      </div>
      <div
        style={{
          height: "46px",
          fontSize: "0.9rem",
          width: "48%",
          border: "1px solid #d0d0d0",
          borderRadius: "7px",
          background: "#fff",
          boxSizing: "border-box",
          float: "right",
          display: "flex",
          padding: "5px",
          paddingLeft: "15px",
        }}
      >
        <div style={{ width: "78%" }}>
          <input
            type="number"
            pattern="\d*"
            name="injctDose"
            style={{ border: "0px", width: "100%", height: "100%" }}
            placeholder="용량"
            onChange={(e) => {
              maxLengthCheck(e, 3) &&
                (e.target.value
                  ? setInjctDose(e.target.value)
                  : setInjctDose(1));
            }}
          />
        </div>
        <div
          style={{
            width: "10%",
            lineHeight: "35px",
            color: "rgb(156, 156, 156)",
          }}
        >
          IU
        </div>
      </div>
    </div>
  );
};
